/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  Badge, Icon, ICON_IMAGE_OUTLINE, Image, ImageProps,
} from '@doveit/bricks';
import * as styles from './CanvaDesignPreview.style';

export interface CanvaDesignPreviewProps extends React.AriaAttributes, Pick<ImageProps, 'alt' | 'height'> {
  src?: string,
  badgeLabel?: string,
  boxed?: boolean,
  aspectRatio?: number,
  color?: 'primary' | 'neutral',
  iconPlaceholder?: string,
}

const CanvaDesignPreview: React.FC<CanvaDesignPreviewProps> = ({
  src,
  alt,
  'aria-label': ariaLabel = 'canva-design-preview',
  badgeLabel,
  boxed = false,
  height,
  aspectRatio,
  color = 'neutral',
  iconPlaceholder = ICON_IMAGE_OUTLINE,
  ...rest
}) => (
  <div
    aria-label={ariaLabel}
    {...rest}
    css={styles.preview}
    $boxed={boxed}
    $color={color}
    $aspectRatio={aspectRatio}
    $height={height}
  >
    <div
      css={styles.imagePlaceholder}
      $color={color}
    >
      <Icon
        size={64}
        path={iconPlaceholder}
      />
    </div>
    {src && (
      <div css={styles.imageWrapper}>
        <Image
          src={src}
          alt={alt}
          height={height}
          responsive
        />
      </div>
    )}
    {badgeLabel && (
      <div css={styles.typeBadge}>
        <Badge
          label={badgeLabel}
          color={color}
          emphasis="low"
          size="XS"
          aria-label="Badge di tipo"
        />
      </div>
    )}
  </div>
);

export default CanvaDesignPreview;
